import { render, staticRenderFns } from "./MerchBlock.vue?vue&type=template&id=1d41145c"
import script from "./MerchBlock.vue?vue&type=script&lang=js"
export * from "./MerchBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports